"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWhatsNewFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M31.6 16l-5.31-4.27L27 5l-6.77.73L16 .4l-4.26 5.3L5 5l.74 6.76L.4 16l5.31 4.26L5 27l6.77-.73L16 31.59l4.26-5.3L27 27l-.74-6.76zM15 10h2v7h-2zm1 12a1.5 1.5 0 110-3 1.5 1.5 0 110 3z" })));
}
exports.default = SvgWhatsNewFilled;
//# sourceMappingURL=WhatsNewFilled.js.map